import {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  PROJECT_CREATION_PATH,
  setProjectCreationInitiatedFrom,
} from '../../../../redux/slices/projectCreationSlice';
import {RootState} from '../../../../redux/store';
import AurButton from '../../../common/aur-button/AurButton';
import {t} from 'i18next';

interface Props {
  isCaptionTypeBack?: boolean;
}

const BackToClientButton: React.FC<Props> = ({isCaptionTypeBack = true}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const stringPath = `projectCreation.common.${isCaptionTypeBack ? 'back.' : 'return.'}`;
  const projectCreationInitiatedFrom = useSelector(
    (state: RootState) => state.projectCreation.projectCreationInitiatedFrom
  );

  const returnToButtonTitle = useMemo(() => {
    switch (projectCreationInitiatedFrom) {
      case PROJECT_CREATION_PATH.ClientDetails:
        return stringPath + 'returnToClientDetails';
      case PROJECT_CREATION_PATH.ClientOverview:
      default:
        return stringPath + 'returnToClientOverview';
    }
  }, [projectCreationInitiatedFrom]);

  const onBackToButtonClick = () => {
    switch (projectCreationInitiatedFrom) {
      case PROJECT_CREATION_PATH.ClientDetails:
        navigate('/clients/details', {replace: true});
        break;
      case PROJECT_CREATION_PATH.ClientOverview:
      default:
        navigate('/welcome-single-client', {replace: true});
        break;
    }
    dispatch(setProjectCreationInitiatedFrom(null));
  };
  return (
    <AurButton
      label={t(returnToButtonTitle)}
      type="continue"
      size="Large"
      dataTestId="back-to-client-button"
      onClick={onBackToButtonClick}
    />
  );
};

export default BackToClientButton;
